import { inject, Injectable } from '@angular/core';
import { filter, Observable, take } from 'rxjs';
import { Store } from '@lib.core/store/store.service';
import { Context } from '@lib.core/context/context';
import { ContextService } from '@lib.core/context/context-service';

@Injectable({
  providedIn: 'root'
})
export class ContextStore implements ContextService {
  private readonly store = inject(Store);


  setContext(ctx: Context) {
    this.store.setValue(ctx.nameId, ctx);
  }

  updateContextLang(contextNameId: string, lang: string) {
    this.store.getValue<Context>(contextNameId)
      .pipe(
        filter((ctx: Context | null | undefined) => !!ctx),
        take(1),
      ).subscribe({
      next: (ctx: Context) => {
        ctx.lang = lang;
        this.store.setValue(ctx.nameId, ctx);
      }
    });
  }

  getContextByNameId(nameId: string): Observable<Context | undefined> {
    return this.store.getValue<Context>(nameId).pipe(filter((ctx: Context | null | undefined) => ctx !== null));
  }

}
